import React, { ReactNode } from "react";

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="login-container">
      <div className="login-content-wrapper">
        <div className="login-left-section">
          <h1 className="login-heading">Toolmaking Reinvented </h1>
          <p className="login-description">
            Automate your toolmaking<br />
            operations while reducing lead<br />
            times and costs.
          </p>
          <div className="login-links">
            <a href="/nda" className="login-link">NDA</a>
            <span className="login-separator"> | </span>
            <a href="/faqs" className="login-link">FAQs</a>
          </div>
        </div>
        
        <div className="login-form">
          <div className="mantle-logo"></div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
